"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const MergePatchConverter_1 = require("./MergePatchConverter");
const Customer_1 = require("../Model/Customer");
class CustomerMergePatchConverter extends MergePatchConverter_1.default {
    getValueMapping() {
        return {
            first_name: Customer_1.default.prototype.getFirstName,
            last_name: Customer_1.default.prototype.getLastName,
            email: Customer_1.default.prototype.getEmail,
            phone_number: Customer_1.default.prototype.getPhoneNumber,
            postal_code: Customer_1.default.prototype.getPostalCode,
            additional_comments: Customer_1.default.prototype.getComment,
            privacy_policy: Customer_1.default.prototype.hasPrivacyPolicy,
            subscribed_to_newsletter: Customer_1.default.prototype.isSubscribed,
            subscriptions: Customer_1.default.prototype.getSubscriptions,
        };
    }
    /**
     * Convert data from the initial customer and the updated one for the needed update operation json.
     *
     * @param customerData {}
     * @param oldCustomer Customer
     *
     * @returns {}
     */
    convertCustomerToUpdateCustomerData(customerData, oldCustomer) {
        let dataToSend = { "changes": [] };
        const oldData = this.convert(oldCustomer, this.getValueMapping());
        Object.keys(customerData).forEach(key => {
            if (customerData[key] !== oldData[key]) {
                if (customerData[key] === null) {
                    dataToSend.changes.push({
                        "op": "remove",
                        "path": key,
                    });
                }
                else {
                    dataToSend.changes.push({
                        "op": "replace",
                        "path": key,
                        "oldValue": oldData[key],
                        "newValue": customerData[key]
                    });
                }
            }
        });
        return dataToSend;
    }
}
exports.default = CustomerMergePatchConverter;
